import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import "@/index.css";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import PolicyPage from "@/pages/PolicyPage";
import Admin from "@/pages/Admin";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "140px 24px", fontFamily: "IBM Plex Sans, sans-serif", maxWidth: 640, margin: "0 auto" }}>
          <h1 className="font-display text-3xl font-bold" style={{ color: "#0A2540" }}>Something went wrong</h1>
          <p style={{ color: "#475569", marginTop: 12 }}>
            Please refresh the page. For assistance, call Eli Capital Investments at 954-702-3558.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Noise = () => <div className="noise-overlay" aria-hidden="true" />;

const Shell = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <>
      <Nav variant={pathname === "/" ? "home" : "minimal"} />
      {children}
    </>
  );
};

function App() {
  React.useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf = requestAnimationFrame(function loop(t) {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    });
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Noise />
        <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<PolicyPage kind="privacy" />} />
            <Route path="/terms-of-sale" element={<PolicyPage kind="terms" />} />
            <Route path="/shipping" element={<PolicyPage kind="shipping" />} />
            <Route path="/refund" element={<PolicyPage kind="refund" />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Shell>
        <Footer />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
